import React, { useState } from 'react';
import { MenuItem } from '@mui/material';
import { IInspection } from 'pages/SchedulerList/components/Inspection/Inspection.types';
import PhotoService from 'services/PhotoService/photoService';
import DocumentService from 'services/DocumentService/documentService';
import { toast } from 'react-toastify';

interface IDownloadRegulationMenuItemProps {
  inspection: IInspection;
  onCloseMenu: () => void;
}

const DownloadRegulationMenuItem = ({ inspection, onCloseMenu }: IDownloadRegulationMenuItemProps) => {
  const [loading, setLoading] = useState(false);

  const regulationPhotos = inspection.photos?.filter((photo) => photo.origin === 'UPLOAD_KITE_REGULATION') || [];
  const regulationDocuments = inspection.files?.filter((file) => file.origin === 'UPLOAD_KITE_REGULATION') || [];

  const hasRegulationFiles = regulationPhotos.length > 0 || regulationDocuments.length > 0;

  const handleDownload = async () => {
    if (!hasRegulationFiles) {
      toast.warning('Não há arquivos de regulação para baixar');
      return;
    }

    setLoading(true);
    onCloseMenu();

    try {
      const downloadPromises = [];

      // Download photos
      if (regulationPhotos.length > 0) {
        const photoIds = regulationPhotos.map((photo) => photo.id).filter(Boolean) as string[];
        if (photoIds.length > 0) {
          downloadPromises.push(PhotoService.downloadPhotos(regulationPhotos));
        }
      }

      // Download documents
      if (regulationDocuments.length > 0) {
        regulationDocuments.forEach((doc) => {
          downloadPromises.push(DocumentService.downloadDocument(doc));
        });
      }

      await Promise.all(downloadPromises);
      toast.success('Download dos arquivos de regulação iniciado!');
    } catch (error) {
      toast.error('Erro ao baixar arquivos de regulação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MenuItem data-testid="download-regulation" onClick={handleDownload} disabled={!hasRegulationFiles || loading}>
      Baixar Arquivos de Regulação
    </MenuItem>
  );
};

export default DownloadRegulationMenuItem;
